(function() {
	PM.McpIntegration = {};

	PM.McpIntegration.renderSection = function() {
		if (!PM.Shell.checkFeature('mcp')) {
			PM.McpIntegration._renderUpgrade();
			return;
		}
		$.when(
			$.get('/api/integrations/mcp'),
			ejs.preloadTemplate('/app/config/integrations/mcp/templates/mcp.ejs')
		).done(function(mcpResult) {
			var data = mcpResult[0];
			var html = ejs.rr('/app/config/integrations/mcp/templates/mcp.ejs', data);
			PM.Config.renderSection('integrations/mcp', html);
			PM.McpIntegration.renderLog();
		});
	};

	PM.McpIntegration.render = function() {
		if (!PM.Shell.checkFeature('mcp')) {
			PM.McpIntegration._renderUpgrade();
			return;
		}
		$.when(
			$.get('/api/integrations/mcp'),
			ejs.preloadTemplate('/app/config/integrations/mcp/templates/mcp.ejs')
		).done(function(mcpResult) {
			var data = mcpResult[0];
			var html = ejs.rr('/app/config/integrations/mcp/templates/mcp.ejs', data);
			$('.js-page-container').html(html);
			PM.McpIntegration.renderLog();
		}).always(function() {
			PM.McpIntegration._rendering = false;
		});
	};

	PM.McpIntegration.renderLog = function() {
		$.get('/api/logs?source=mcp&limit=50').done(function(entries) {
			var $panel = $('.js-mcp-log-panel');
			var $list = $panel.find('.js-mcp-log-entries');
			$list.empty();

			if (entries.length === 0) return;

			$panel.show();

			for (var i = 0; i < entries.length; i++) {
				var entry = entries[i];
				var badgeClass = entry.level === 'error' ? 'bg-danger' : entry.level === 'warn' ? 'bg-warning text-dark' : 'bg-secondary';
				var time = new Date(entry.createdAt).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', second: '2-digit' });
				var $item = $('<div class="list-group-item py-1 px-2 d-flex align-items-start gap-2"></div>');
				$item.append('<small class="text-muted text-nowrap">' + time + '</small>');
				$item.append('<span class="badge ' + badgeClass + ' text-nowrap" style="font-size:0.7rem;">' + entry.level + '</span>');
				$item.append('<span>' + entry.message + '</span>');
				$list.append($item);
			}
		});
	};

	$(document).on('change', '.js-mcp-enabled', function() {
		var enabled = $(this).is(':checked');
		$.ajax({
			url: '/api/integrations/mcp',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify({ enabled: enabled })
		}).done(function() {
			PM.McpIntegration.render();
		});
	});

	$(document).on('click', '.js-mcp-regenerate-key', function() {
		if (!confirm(i18next.t('Regenerate the read-write API key? All clients using this key will need the new key.'))) return;
		$.ajax({
			url: '/api/integrations/mcp',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify({ regenerate_key: true })
		}).done(function() {
			PM.McpIntegration.render();
		});
	});

	$(document).on('click', '.js-mcp-regenerate-ro-key', function() {
		if (!confirm(i18next.t('Regenerate the read-only API key? All clients using this key will need the new key.'))) return;
		$.ajax({
			url: '/api/integrations/mcp',
			method: 'PUT',
			contentType: 'application/json',
			data: JSON.stringify({ regenerate_readonly_key: true })
		}).done(function() {
			PM.McpIntegration.render();
		});
	});

	$(document).on('click', '.js-mcp-disconnect', function() {
		if (!confirm(i18next.t('Disconnect MCP? The API key will be destroyed.'))) return;
		$.ajax({
			url: '/api/integrations/mcp',
			method: 'DELETE'
		}).done(function() {
			PM.McpIntegration.render();
		});
	});

	$(document).on('click', '.js-copy-key', function() {
		var $input = $(this).closest('.input-group').find('input');
		$input.select();
		document.execCommand('copy');
		new Notify({ status: 'success', text: i18next.t('API key copied'), timeout: 2000 });
	});

	$(document).on('click', '.js-mcp-log-refresh', function() {
		PM.McpIntegration.renderLog();
	});

	PM.McpIntegration._renderUpgrade = function() {
		ejs.preloadTemplate('/app/shell/templates/upgrade-required.ejs').then(function() {
			var html = ejs.rr('/app/shell/templates/upgrade-required.ejs', {});
			PM.Config.renderSection('integrations/mcp', html);
		});
	};
})();
